// Sync Manager - handles automatic syncing of offline data
import { getPendingNota, markNotaSynced, deleteSyncedNota } from './offlineDb';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Sync all pending nota to backend
export const syncPendingNota = async (token) => {
  try {
    const pendingNota = await getPendingNota();
    
    if (pendingNota.length === 0) {
      return { success: true, synced: 0, failed: 0 };
    }

    let syncedCount = 0;
    let failedCount = 0;

    for (const nota of pendingNota) {
      try {
        // Remove IndexedDB specific fields before sending
        const { id, timestamp, synced, ...notaData } = nota;

        const response = await fetch(`${BACKEND_URL}/api/nota`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(notaData)
        });

        if (response.ok) {
          // Mark as synced and delete from IndexedDB
          await markNotaSynced(id);
          await deleteSyncedNota(id);
          syncedCount++;
        } else {
          failedCount++;
          console.error('Failed to sync nota:', await response.text());
        }
      } catch (error) {
        failedCount++;
        console.error('Error syncing individual nota:', error);
      }
    }

    return { 
      success: syncedCount > 0, 
      synced: syncedCount, 
      failed: failedCount 
    };
  } catch (error) {
    console.error('Error in syncPendingNota:', error);
    return { success: false, synced: 0, failed: 0, error };
  }
};

// Start automatic sync when online
export const startAutoSync = (token, onSyncStart, onSyncComplete) => {
  const handleOnline = async () => {
    if (onSyncStart) onSyncStart();
    
    try {
      const result = await syncPendingNota(token);
      if (onSyncComplete) {
        onSyncComplete(result);
      }
    } catch (error) {
      console.error('Auto-sync failed:', error);
      if (onSyncComplete) {
        onSyncComplete({ success: false, error });
      }
    }
  };

  // Listen for online event
  window.addEventListener('online', handleOnline);

  // Return cleanup function
  return () => {
    window.removeEventListener('online', handleOnline);
  };
};
